import { render, staticRenderFns } from "./ManageTrading.vue?vue&type=template&id=3cb8eb2c&scoped=true&"
import script from "./ManageTrading.vue?vue&type=script&lang=js&"
export * from "./ManageTrading.vue?vue&type=script&lang=js&"
import style0 from "./ManageTrading.vue?vue&type=style&index=0&id=3cb8eb2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb8eb2c",
  null
  
)

export default component.exports